module.exports = __webpack_public_path__ + "static/media/vanellope.b654b2a8.jpg";